import React from 'react';
import './Login.css';
import axios from 'axios';
import Logoicono from '../Componentes/logosvg2';
import toast, { Toaster } from 'react-hot-toast';
import { useNavigate} from 'react-router-dom';

function Login({Corrion}) {

    axios.defaults.withCredentials = true;
    const navigate = useNavigate();

    const handleLogin = (e) => {
        e.preventDefault();
        const form = e.target;
        axios.post(`${process.env.REACT_APP_HTTPS}/api/user/login`, {user: form.loguser.value, password: form.logpass.value})
        .then(response => {
            if (response){
            toast.success('Bienvenido', {position: 'top-center'});
            Corrion()
            navigate('/', {state:{from: 'ready'}});
        }
        })
        .catch(error => {
            console.error('Error al inciar sesion:', error);
            toast.error('Usuario y contrasena no coinciden', {position: 'top-center'});
            return ; 
        });
    };
    
    function getCanchas() {
        navigate('/RegistroEstablecimiento')
      }
    function gotoContra() {
    navigate('/CambiodeContrasena')
    }
  return (
    <>
        <div className="Login">
            <div> 
                <div className='Ltitulo'><div className='Llogotitulo'><Logoicono/></div><p style={{color: 'white', fontSize: '40px'}}>Chamuscón</p></div>
                <div className="loglogin">
                    <h2>Inicia sesión</h2> <br/>
                    <form name="login" onSubmit={handleLogin}>
                        <p>Usuario: </p>
                        <input className="loguser" type="text" name="loguser" required /> <br />
                        <p>Contraseña: </p>
                        <input className="logpass" type="password" name="logpass" required /> <br />
                        <button type="submit">Login</button> <br/>
                        <button onClick={getCanchas}>Registrarse</button>
                    </form>
                    <p onClick={gotoContra} style={{fontSize: '12px', color:'blue', cursor:'pointer', margin:"5px"}}>Olvidé mi contraseña</p>
                </div>
            </div>
        </div>
        <Toaster />
    </>
  );
}

export default Login;